import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import RubriqAbstractCopyDownload from './RubriqAbstractCopyDownload';
var ACCENT_ICON_CLASS = {
  blue: 'rubriq-abstract-section-icon-blue',
  purple: 'rubriq-abstract-section-icon-purple'
};
var ACCENT_BOX_CLASS = {
  blue: 'rubriq-abstract-section-box-blue',
  purple: 'rubriq-abstract-section-box-purple'
};
var RubriqAbstractSection = function RubriqAbstractSection(_ref) {
  var heading = _ref.heading,
    icon = _ref.icon,
    accent = _ref.accent,
    copyTooltip = _ref.copyTooltip,
    downloadTooltip = _ref.downloadTooltip,
    filename = _ref.filename,
    failureMessage = _ref.failureMessage,
    getPlainText = _ref.getPlainText,
    getDocxParagraphs = _ref.getDocxParagraphs,
    hasContent = _ref.hasContent,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2 p-3 border-top"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fs-5 fw-semibold m-0 d-flex align-items-center gap-2"
  }, icon && /*#__PURE__*/React.createElement("span", {
    className: "rubriq-abstract-section-icon ".concat(ACCENT_ICON_CLASS[accent] || '')
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: icon
  })), /*#__PURE__*/React.createElement(T, {
    source: heading
  })), /*#__PURE__*/React.createElement(RubriqAbstractCopyDownload, {
    copyTooltip: copyTooltip,
    downloadTooltip: downloadTooltip,
    filename: filename,
    getPlainText: getPlainText,
    getDocxParagraphs: getDocxParagraphs
  })), hasContent ? accent ? /*#__PURE__*/React.createElement("div", {
    className: "rubriq-abstract-section-box ".concat(ACCENT_BOX_CLASS[accent] || '')
  }, children) : children : /*#__PURE__*/React.createElement("p", {
    className: "text-danger mb-0"
  }, failureMessage));
};
export default RubriqAbstractSection;